import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Intro.css";
import generalHealth from "../../../img/test-images/intro-images/generalhealth-intro.svg";
function Intro() {
  return (
    <div className="intro-div">
      <Container className="intro-container">
        <Row>
          <Col md={6}>
            <img src={generalHealth} alt="general-health-questionnaire" />
          </Col>
          <Col md={6}>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <br />
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/general-health/quiz"
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro;
